import { useState, useEffect, useContext, useCallback } from 'react'
import { AuthContext } from '../../../../Api/firebase'
import { StorageContext } from '../../../../Context'
import { checkCanSubmitToday } from '../../../../Utils/AllStar/allStarHelper'
import { STORAGE_NAMES } from '../../../../Constants/storage'

const useQuery = () => {
  return new URLSearchParams(window.location.search)
}

export const useEmail = () => {
  const query = useQuery()
  const { email: em, authLoading, isLoggedIn, userId } = useContext(AuthContext)!
  const [email, setEmail] = useState<string>('')
  const emailFromQuery = query.get('email')

  useEffect(() => {
    if (emailFromQuery) {
      setEmail(emailFromQuery)
    } else if (em) {
      setEmail(em)
    }
  }, [em, emailFromQuery, authLoading, userId, isLoggedIn])

  return { email, setEmail }
}

export const useVoteStatus = () => {
  const { userId, authLoading, isLoggedIn } = useContext(AuthContext)!
  const { isStorageReady, getStoredData } = useContext(StorageContext)!
  const [canVote, setCanVote] = useState<boolean>(true)

  const getLastVoteDate = useCallback(async () => {
    if (!isStorageReady) return null
    const { data } = await getStoredData(STORAGE_NAMES.allStarVoteDate)
    return data ?? null
  }, [isStorageReady, getStoredData])

  useEffect(() => {
    const checkVoteStatus = async () => {
      if (!isStorageReady || authLoading || !isLoggedIn) return
      const lastVoteDate = await getLastVoteDate()
      if (!lastVoteDate) {
        setCanVote(true)
        return
      }
      setCanVote(checkCanSubmitToday(lastVoteDate))
    }

    checkVoteStatus()
  }, [isStorageReady, getLastVoteDate, userId, authLoading, isLoggedIn])

  return { canVote, setCanVote }
}
